import { render, staticRenderFns } from "./EmployerSidebar.vue?vue&type=template&id=55b4d60b&scoped=true&"
import script from "./EmployerSidebar.vue?vue&type=script&lang=js&"
export * from "./EmployerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EmployerSidebar.vue?vue&type=style&index=0&id=55b4d60b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b4d60b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
